import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { api } from 'services';
import MasterPage from 'components/MasterPage';
import ListingReports from 'components/ListingReports';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { DashboardOutlined } from '@material-ui/icons';
import ExportTable from 'components/ExportTable';

const GeneralReport = () => {
  const defaultFilters = { __search: '', per_page: 10, page: 1 };
  const [reports, setReports] = useState({ data: [], pagination: {} });
  const [filters, setFilters] = useState(defaultFilters);
  const [load, setLoad] = useState(true);

  const { t } = useTranslation();

  useEffect(() => {
    setLoad(true);
    api
      .get('report-general', { params: { ...filters } })
      .then(({ data }) => {
        setReports(data)
        setLoad(false);
      });
  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:general report')}</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <ExportTable
                  buttonText={t('label:export')}
                  fileName="general-report"
                  data={async (filters) => {
                    let filters_aux = { ...filters };
                    let _r = await (api.get('report-general', { params: { ...filters_aux } }));
                    return _r;
                  }}
                  fields={[
                    {
                      name: t('label:company'), key: 'name|alias', type: 'two_string',
                      mask: (report) => {
                        return `${report.name} / ${report.alias}`
                      }
                    },
                    {
                      name: 'collected', type: 'collected', mask: (report) => {
                        return parseFloat(report.fund_value_currency_real).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                      }
                    },
                    {
                      name: 'invoiced amount', type: 'invoiced amount', mask: (report) => {
                        let text = 0;
                        report.actions.map(action => {
                          if (action.status_id == 17 || action.status_id == 18) {
                            text += parseFloat(action.invoiced_amount);
                          }
                        });
                        return text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                      }
                    },
                    {
                      name: 'total spent', type: 'total spent', mask: (report) => {
                        let text = 0;
                        report.actions.map(action => {
                          text =
                            action.status_id !== 19
                              ? (text += parseInt(action.actual_value))
                              : 0;
                        });
                        return text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                      }
                    },
                    { name: 'margin', type: 'margin' },
                    {
                      name: 'received', type: 'received', mask: (report) => {
                        let text = 0;
                        report.actions.map(action => {
                          text += action.received
                        });
                        return text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                      }
                    },
                    {
                      name: 'to profit', type: 'to profit', mask: (report) => {
                        let text = 0;
                        report.actions.map(action => {
                          text =
                            action.status_id === 13
                              ? (text += parseInt(action.actual_value))
                              : 0;
                        });
                        return text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                      }
                    }
                  ]}
                  filters={filters}
                  stateFilters={filters}
                  setFilters={setFilters}
                  reports={reports}

                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <ListingReports
                  load={load}
                  fields={[
                    {
                      name: t('label:company'), key: 'name|alias', type: 'two_string',
                      mask: (report) => {
                        return `${report.name} / ${report.alias}`
                      }
                    },
                    {
                      name: 'collected', type: 'collected', mask: (report) => {
                        return parseFloat(report.fund_value_currency_real).toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                      }
                    },
                    {
                      name: 'invoiced amount', type: 'invoiced amount', mask: (report) => {
                        let text = 0;
                        report.actions.map(action => {
                          if (action.status_id == 17 || action.status_id == 18) {
                            text += parseFloat(action.invoiced_amount);
                          }
                        });
                        return text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                      }
                    },
                    {
                      name: 'total spent', type: 'total spent', mask: (report) => {
                        let text = 0;
                        report.actions.map(action => {
                          text =
                            action.status_id !== 19
                              ? (text += parseInt(action.actual_value))
                              : 0;
                        });
                        return text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                      }
                    },
                    { name: 'margin', type: 'margin' },
                    {
                      name: 'received', type: 'received', mask: (report) => {
                        let text = 0;
                        report.actions.map(action => {
                          text += action.received
                        });
                        return text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                      }
                    },
                    {
                      name: 'to profit', type: 'to profit', mask: (report) => {
                        let text = 0;
                        report.actions.map(action => {
                          text =
                            action.status_id === 13
                              ? (text += parseInt(action.actual_value))
                              : 0;
                        });
                        return text.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL'
                        });
                      }
                    }
                  ]}
                  filters={[]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  reports={reports}
                  handleFilterChange={handleFilterChange}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

const mapStateToProps = state => ({});
const reduxConnect = connect(mapStateToProps)(GeneralReport);

export default MasterPage(reduxConnect);
